export default "__VITE_ASSET__DYwcdZ7K__"